export default class OtherActivitiesListCtrl {

  constructor ($scope, WorkPlanSrv, $mdDialog, WorkPlanIndicatorSrv, WorkPlanModalSrv, $cookies, GlobalConfig, Requests, $timeout, $sessionStorage) {
    var activitiesVm = this
    const currentUser = JSON.parse($cookies.get('currentUser'))

    activitiesVm.activities = []
    activitiesVm.idWorkPlan = currentUser.workplanId
    activitiesVm.idTeacher = currentUser.teacherId
    activitiesVm.active = GlobalConfig.generals.active
    activitiesVm.notActive = GlobalConfig.generals.notActive
    activitiesVm.filterSearchResult = GlobalConfig.appTexts.filterResult.unSatisfactory
    activitiesVm.imgEmpty = require('../../../../../../assets/images/empty_state_illustration.svg')
    activitiesVm.planningFinish = true
    $scope.classPlanning = ''
    activitiesVm.inReview = 0
    activitiesVm.feedback = 0
    activitiesVm.viewLoaded = false
    activitiesVm.workPlanGeneralList = $sessionStorage.workPlanGeneralList
    activitiesVm.$sessionStorage = $sessionStorage

    // modals
    activitiesVm.updateView = updateView
    activitiesVm.confirmDisableActivity = confirmDisableActivity
    activitiesVm.getGeneralsWorkplan = getGeneralsWorkplan
    activitiesVm.bitacora = bitacora

    activate()

    function activate() {
      let header = {
        teacherId: currentUser.teacherId,
        workplanId: currentUser.workplanId
      }

      if(activitiesVm.workPlanGeneralList != undefined){
        activitiesVm.status = activitiesVm.workPlanGeneralList.wokplanTeacherStatus[0]
        activitiesVm.stages = activitiesVm.workPlanGeneralList.stages
        activitiesVm.inReview = activitiesVm.status.reviewed
        activitiesVm.feedback = activitiesVm.status.feedbackReviewed
        activitiesVm.workplanTeacherId = activitiesVm.status.workplanTeacherId
        isPlanning(activitiesVm.status, activitiesVm.stages)

        if(activitiesVm.feedback && !activitiesVm.planningFinish){
          getOtherActivityItemAMReject(header)
        }else{
          getListOtherActivityItemAM(header)
        }
      }else{
        getGeneralsWorkplan(header).then((promise) => {
          if(activitiesVm.feedback && !activitiesVm.planningFinish){
            getOtherActivityItemAMReject(header)
          }else{
            getListOtherActivityItemAM(header)
          }
        })
      }
    }

    function getListOtherActivityItemAM (header){
       WorkPlanSrv.getListOtherActivityItemAM.get(header).$promise.then(function(dataReturn) {
        if(dataReturn.status){
          activitiesVm.activities = dataReturn.data
        }else{
          console.log("Comunications problem with the server")
        }
      },function(data) {
           console.log(data)
      })
    }

    function getOtherActivityItemAMReject (header){
       WorkPlanSrv.getOtherActivityItemAMReject.get(header).$promise.then(function(dataReturn) {
        if(dataReturn.status){
          activitiesVm.activities = dataReturn.data
        }else{
          console.log("Comunications problem with the server")
        }
      },function(data) {
           console.log(data)
      })
    }

    function updateView () {
      activitiesVm.viewLoaded = false
      $timeout(() => {
        activitiesVm.viewLoaded = true
      }, 1000)
    }

    function confirmDisableActivity (row) {
      let activityArray = activitiesVm.activities.indexOf(row)
      let workplanTeacherActivityId = row.workplanTeacherActivityId
      let deleteActivityName = row.listItemName
      $mdDialog.show({
        controller: ['$scope', '$mdDialog', 'WorkPlanSrv', 'WorkPlanIndicatorSrv', function ($scope, $mdDialog, WorkPlanSrv, WorkPlanIndicatorSrv) {
          let ctrlModalVM = this
          ctrlModalVM.activityArrayCode = activityArray
          ctrlModalVM.workplanTeacherActivityId = workplanTeacherActivityId
          ctrlModalVM.delActivityName = deleteActivityName
          ctrlModalVM.close = function () {
            $mdDialog.hide()
          }
          ctrlModalVM.disableOtherActivity = function () {
            WorkPlanSrv.disableActivity.delete({workplanTeacherActivityId: ctrlModalVM.workplanTeacherActivityId})
            .$promise.then(function (dataReturn) {
              if (dataReturn.status) {
                // se hace set de variable para actualizar los indicadores
                // se comunica con el controlador de Indicadores
                WorkPlanIndicatorSrv.setVariable(true)
                activitiesVm.activities.splice(ctrlModalVM.activityArrayCode, 1)
                $mdDialog.hide()
                showModalDeleteSuccess(deleteActivityName)
              } else {
                console.log('Comunications problem with the server')
              }
            }, function (data) {

            })
          }
        }],
        controllerAs: 'ctrlModalVM',
        template: require('./disableActivityModal.html'),
        clickOutsideToClose: false
      })
    }

    function showModalDeleteSuccess(deleteActivityName) {

      let texts = GlobalConfig.appTexts
      let header = {
        createOrEdit     : texts.deleteDialog,
        textCreateOrEdit : texts.deleted,
        itemName         : deleteActivityName,
        nameModal        : texts.modalTypeName.deleted,
        modalType        : texts.modalTypeId.default
      }
      WorkPlanModalSrv.setVariableSuccessDialog(header)
      WorkPlanModalSrv.successDialog(header).then((promise) => { })
      
    }

    function getGeneralsWorkplan(post){
      return WorkPlanSrv.getElementsRightBar.getList({teacherId: post.teacherId}).$promise.then(function(dataReturn) {
        if(dataReturn.status){
          activitiesVm.$sessionStorage.workPlanGeneralList = dataReturn.data
          activitiesVm.status = dataReturn.data.wokplanTeacherStatus[0]
          activitiesVm.stages = dataReturn.data.stages
          activitiesVm.inReview = activitiesVm.status.reviewed
          activitiesVm.feedback = activitiesVm.status.feedbackReviewed
          activitiesVm.workplanTeacherId = activitiesVm.status.workplanTeacherId
          isPlanning(activitiesVm.status, activitiesVm.stages)
        }else{
          console.log("Comunications problem with the server")
        }
      },function(data) {
           console.log(data);
      })
    }

    function isPlanning(status, stages){
      activitiesVm.currentDate = moment(new Date()).format("DD/MM/YYYY")
      for (var i = stages.length - 1; i >= 0; i--) {
        if(stages[i].stageId == GlobalConfig.workplanIdStages.review){
          activitiesVm.startDateStage = stages[i].startDate
        }
      }

      if(status.workplanActive){
        if (status.planningFinish == activitiesVm.active){        
          activitiesVm.planningFinish = true
          if (activitiesVm.startDateReview < activitiesVm.currentDate || status.reviewedFinish == activitiesVm.active){
            activitiesVm.planningFinish = true
          }else if (status.reviewedReject == activitiesVm.active){
            activitiesVm.planningFinish = false
          }
        } else {
            activitiesVm.planningFinish = false
        }
      }else{
        activitiesVm.planningFinish = true
      }
      
      $scope.classPlanning = (activitiesVm.planningFinish ? "disabled" : " ")
    }

    function bitacora (ev) {
      let entries = {}

      entries.params = {
        activityTypeId: GlobalConfig.activityTypeId.otherActivities,
        workplanTeacherId: activitiesVm.workplanTeacherId
      }
      entries.title = 'Otras Actividades'
      // Entries(this.entries);
      entries.data = undefined
      $mdDialog.show({
        controller: 'bitacoraModalCtrl',
        controllerAs: 'bit',
        template: require('../../../../strategicTracking/detailsByTeacher/bitacoraModal/bitacoraModal.html'),
        parent: angular.element(document.body),
        targetEvent: ev,
        locals: {data: entries},
        clickOutsideToClose: true,
        fullscreen: true
      })
    }

  }//FIN DEL CONSTRUCTOR

    preventInput(event){
      var  vKey = 86
      if (event.keyCode == vKey){
        event.preventDefault()
      }
      return;     
    }
}

OtherActivitiesListCtrl.$inject = ['$scope', 'WorkPlanSrv', '$mdDialog', 'WorkPlanIndicatorSrv', 'WorkPlanModalSrv', '$cookies', 'GlobalConfig', 'Requests', '$timeout', '$sessionStorage']



// WEBPACK FOOTER //
// ./src/app/u-faculty/workplan/academicManagement/otherActivities/listActivities/otherActivitiesListCtrl.js